import * as Long from "long";
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionBuildingsDeselect } from "../../player-base/buildings/actionBuildings";
import { TypeActionTrade } from "../actionTrade";
export var epicBuyProductsConfirmed = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTrade.BuyConfirmed), switchMap(function (action) {
        return deps
            .netSend({
            id: CommandCode.BuyProducts,
            props: {
                amount: action.amount,
                itemId: action.itemId,
                playerId: state$.value.playerInfo.playerId,
            },
        }, true)
            .pipe(switchMap(function (res) {
            return from([
                actionModalClose(IdModal.QuickSell),
                actionInventoryInfoRemoveResource(res.cost),
                actionBuildingsDeselect(),
            ]);
        }), catchError(function (err) {
            return of(actionInventoryInfoRemoveResource([
                { typeId: action.itemId, amount: Long.fromValue(action.amount) },
            ]));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/epics/epicBuyProductsConfirmed.ts
// module id = 2453
// module chunks = 3